import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./component/HomePage";
import BackButton from "./component/BackButton";
import MasterPage from "./Master/MasterPage";
import DepartmentList from "./Master/DepartmentList";
import DepartmentMaster from "./Master/DepartmentMaster";
import DesignationMaster from "./Master/DesignationMaster";
import DesignationList from "./Master/DesignationList";
import LeaveTypeMaster from "./Master/leavetypemaster";
import LeaveTypeList from "./Master/leavetypelist";
import HolidayMaster from "./Master/HolidayMaster";
import HolidayList from "./Master/HolidayList";
import ShiftMaster from "./Master/Shiftmaster";
import ShiftList from "./Master/Shiftlist";
import PolicyMaster from "./Master/Policymaster";
import PolicyList from "./Master/PolicyList";
import LocationMaster from "./Master/LocationMaster";
import LocationList from "./Master/Locationlist";
import PayrollComponentMaster from "./Master/PayrollComponentMaster";
import PayrollComponentList from "./Master/PayrollComponentList";
import EmployeeMaster from "./Master/EmployeeMaster";
import EmployeeList from "./Master/EmployeeList";
import LeaveDashboard from "./Master/LeaveDashboard";
import Dashboard from "./component/Dashboard";
import AdminLogin from "./component/AdminLogin";
import EditProfile from "./component/EditProfile";
import ChangePassword from "./component/ChangePassword";
import AdminManagement from "./component/AdminManagement";
import { Toaster } from "react-hot-toast";
import LeaveRuleMaster from "./Master/LeaveRuleMaster";
import LeaveRuleList from "./Master/LeaveRuleList";
import LeaveAllocationForm from "./Master/LeaveAllocationForm";
import LeaveAllocationList from "./Master/LeaveAllocationList";
import EmployeeDashboard from "./EmployeeCorner/EmployeeDashboard";
import UserProfile from "./EmployeeCorner/UserProfile";
import EmployeeHome from "./EmployeeCorner/EmployeeHome";
import EmployeeCornerSidebar from "./EmployeeCorner/EmployeeCornerSidebar";
import EmployeeUserIdCreated from "./EmployeeCorner/EmployeeUserIdCreated";
import EmployeeCalendar from "./EmployeeCorner/EmployeeCalendar";
import EmployeeLeaveApplication from "./EmployeeCorner/EmployeeLeaveApplication";
import SalaryHeadForm from "./Master/SalaryHeadForm";
import SalarySlipHeadList from "./Master/SalarySlipHeadList";
import PaySlipGenerateEmployeeList from "./Master/PaySlipGenerateEmployeeList";
import GeneratePaySlip from "./Master/GeneratePaySlip";
import PaySlipHistory from "./Master/PaySlipHistory";
import ReminderPage from "./Master/ReminderPage";
import ShiftManagement from "./Master/ShiftManagement";
import EmployeeLeaveDetails from "./EmployeeCorner/EmployeeLeaveDetails";
import EmployeeAttendance from "./EmployeeCorner/EmployeeAttendance";
import EmployeeShiftTime from "./EmployeeCorner/EmployeeShiftTime";
import LeaveHistory from "./Master/LeaveHistory";
import LeaveRecord from "./Master/LeaveRecord";
import EmployeeAttendanceHistory from "./Master/EmployeeAttendanceHistory";
import AttendanceController from "./Master/AttendanceController";
import EmployeePayslipView from "./EmployeeCorner/EmployeePayslipView";
import EmployeeTraining from "./EmployeeCorner/EmployeeTraining";
import AttendanceSignIn from "./component/AttendanceSignIn";
import OtRateMaster from "./Master/OtRateMaster";
import OTRateList from "./Master/OTRateList";
import GenerateAllEmployeePayslip from "./Master/GenerateAllEmployeePayslip";
import QualificationMaster from "./Master/QualificationMaster";
import QualificationList from "./Master/QualificationList";
import Training from "./Master/Training";
import ActivityHistory from "./Master/ActivityHistory";
import TrainingList from "./Master/TrainingList";
import ProtectedRoute from "./component/ProtectedRoute";


export default function App(){
  const admin = (element, permission) => <ProtectedRoute scope="admin" permission={permission}>{element}</ProtectedRoute>;
  const employee = (element) => <ProtectedRoute scope="employee">{element}</ProtectedRoute>;

  return (
    <>
    <Routes>
      <Route path="/Homepage" element={admin(<HomePage/>, "Dashboard_View")} />
      <Route path="/BackButton" element={admin(<BackButton/>)} />
      <Route path="/MasterPage" element={admin(<MasterPage/>)} />
      <Route path="/DepartmentList" element={admin(<DepartmentList/>, "Master_View")} />
      <Route path="/DepartmentMaster" element={admin(<DepartmentMaster/>, "Master_View")} />
      <Route path="/DesignationMaster" element={admin(<DesignationMaster/>, "Master_View")} />
      <Route path="/DesignationList" element={admin(<DesignationList/>, "Master_View")} />
      <Route path="/LeaveTypeMaster" element={admin(<LeaveTypeMaster/>, "Master_View")} />
      <Route path="/LeaveTypeList" element={admin(<LeaveTypeList/>, "Master_View")} />
      <Route path="/HolidayMaster" element={admin(<HolidayMaster/>)} />
      <Route path="/HolidayList" element={admin(<HolidayList/>)} />
      <Route path="/ShiftMaster" element={admin(<ShiftMaster/>, "Master_View")} />
      <Route path="/ShiftList" element={admin(<ShiftList/>, "Master_View")} />
      <Route path="/PolicyMaster" element={admin(<PolicyMaster/>)} />
      <Route path="/PolicyList" element={admin(<PolicyList/>)} />
      <Route path="/LocationMaster" element={admin(<LocationMaster/>)} />
      <Route path="/LocationList" element={admin(<LocationList/>)} />
      <Route path="/PayrollComponentMaster" element={admin(<PayrollComponentMaster/>)} />
      <Route path="/PayrollComponentList" element={admin(<PayrollComponentList/>)} />
      <Route path="/EmployeeMaster" element={admin(<EmployeeMaster/>, "Employee_View")} />
      <Route path="/EmployeeList" element={admin(<EmployeeList/>, "Employee_View")} />
      <Route path="/Dashboard" element={admin(<Dashboard/>, "Dashboard_View")} />
      <Route path="/" element={<AdminLogin/>} />
      <Route path="/EditProfile" element={admin(<EditProfile/>)} />
      <Route path="/ChangePassword" element={admin(<ChangePassword/>)} />
      <Route path="/AdminManagement" element={admin(<AdminManagement/>, "Admin_Management_view")} />
      <Route path="/LeaveDashboard" element={admin(<LeaveDashboard/>, "Leave_Management_View")} />
      <Route path="/LeaveRuleMaster" element={admin(<LeaveRuleMaster/>)} />
      <Route path="/LeaveRuleList" element={admin(<LeaveRuleList/>)} />
      <Route path="/LeaveAllocationForm" element={admin(<LeaveAllocationForm/>)} />
      <Route path="/LeaveAllocationList" element={admin(<LeaveAllocationList/>)} />
      <Route path="/EmployeeDashboard" element={employee(<EmployeeDashboard/>)} />
      <Route path="/UserProfile" element={employee(<UserProfile/>)} />
      <Route path="/EmployeeHome" element={employee(<EmployeeHome/>)} />
      <Route path="/EmployeeCornerSidebar" element={employee(<EmployeeCornerSidebar/>)} />
      <Route path="/EmployeeUserIdCreated" element={admin(<EmployeeUserIdCreated/>, "Admin_Management_view")} />
      <Route path="/EmployeeCalendar" element={employee(<EmployeeCalendar/>)} />
      <Route path="/EmployeeLeaveApplication" element={employee(<EmployeeLeaveApplication/>)} />
      <Route path="/SalaryHeadForm" element={admin(<SalaryHeadForm/>)} />
      <Route path="/SalarySlipHeadList" element={admin(<SalarySlipHeadList/>)} />
      <Route path="/PaySlipGenerateEmployeeList" element={admin(<PaySlipGenerateEmployeeList/>, "Pay_slip_view")} />
      <Route path="/GeneratePaySlip" element={admin(<GeneratePaySlip/>, "Pay_slip_view")} />
      <Route path="/PaySlipHistory" element={admin(<PaySlipHistory/>, "Pay_slip_view")} />
      <Route path="/ReminderPage" element={admin(<ReminderPage/>)} />
      <Route path="/ShiftManagement" element={admin(<ShiftManagement/>, "Shift_Management_view")} />
      <Route path="/EmployeeLeaveDetails" element={employee(<EmployeeLeaveDetails/>)} />
      <Route path="/EmployeeAttendance" element={employee(<EmployeeAttendance/>)} />
      <Route path="/EmployeeShiftTime" element={employee(<EmployeeShiftTime/>)} />
      <Route path="/LeaveHistory" element={admin(<LeaveHistory/>, "Leave_Management_View")} />
      <Route path="/LeaveRecord" element={admin(<LeaveRecord/>, "Leave_Management_View")} />
      <Route path="/EmployeeAttendanceHistory" element={admin(<EmployeeAttendanceHistory/>, "Attendance_history_view")} />
      <Route path="/AttendanceController" element={admin(<AttendanceController/>, "Attendance_history_view")} />
      <Route path="/EmployeePayslipView" element={employee(<EmployeePayslipView/>)} />
      <Route path="/EmployeeTraining" element={employee(<EmployeeTraining/>)} />
      <Route path="/AttendanceSignIn" element={employee(<AttendanceSignIn/>)} />
      <Route path="/OtRateMaster" element={admin(<OtRateMaster/>)} />
      <Route path="/OTRateList" element={admin(<OTRateList/>)} />
      <Route path="/GenerateAllEmployeePayslip" element={admin(<GenerateAllEmployeePayslip/>, "Pay_slip_view")} />
      <Route path="/QualificationMaster" element={admin(<QualificationMaster/>, "Master_View")} />
      <Route path="/QualificationList" element={admin(<QualificationList/>, "Master_View")} />
      <Route path="/ActivityHistory" element={admin(<ActivityHistory/>, "Activity_History_view")} />
      <Route path="/Training" element={admin(<Training/>, "Training_View")} />
      <Route path="/TrainingList" element={admin(<TrainingList/>, "Training_View")} />


     </Routes>
        <Toaster
          reverseOrder={false}
          toastOptions={{
            style: { fontWeight: 600 },
            success: {
              icon: "✅",
              style: { background: "#d1fae5", color: "#065f46" }, // green background
            },
            error: {
              icon: "❌",
              style: { background: "#fee2e2", color: "#991b1b" }, // red background
            },
          }}
        />
</>
  );
}
